// Keep the page header's dropdowns ("...", Actions, custom button groups) on screen.
//
// Bootstrap 4 positions a dropdown with Popper, kept inside its "boundary", which defaults to the
// nearest scroll parent. On a phone the header row can be wider than the screen, or its scroll
// parent is not the screen, and the "..." menu opened past the right edge, where the page's
// overflow-x: hidden cut its labels off (D42, urban, 25 Oct 2026). With boundary "viewport", Popper
// moves the menu back inside the screen whatever the header row does.
//
// Bootstrap reads data-boundary only when it first creates a dropdown, on the toggle's first click
// or key press. A capture listener runs before Bootstrap's own (bubbling) handler, so the attribute
// is in place in time. Only header toggles that do not set a boundary themselves are touched.

const SELECTOR = '.page-head [data-toggle="dropdown"]:not([data-boundary])';

export function keep_on_screen(event) {
	const toggle = event.target instanceof Element ? event.target.closest(SELECTOR) : null;
	if (toggle) toggle.setAttribute("data-boundary", "viewport");
	return toggle;
}

for (const type of ["click", "keydown", "touchstart"]) {
	document.addEventListener(type, keep_on_screen, { capture: true, passive: true });
}
